import { render, staticRenderFns } from "./UserInfo.vue?vue&type=template&id=3a08ac5d&scoped=true&"
import script from "./UserInfo.vue?vue&type=script&lang=ts&"
export * from "./UserInfo.vue?vue&type=script&lang=ts&"
import style0 from "./UserInfo.vue?vue&type=style&index=0&id=3a08ac5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a08ac5d",
  null
  
)

export default component.exports